import { useState, useCallback } from "react";

const usePut = (url, options = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const putData = useCallback(
    async (requestBody) => {
      console.log("put requestBody",requestBody);
      setIsLoading(true);
      try {
        const response = await fetch(url, {
          ...options,
          method: "PUT", // fixed to PUT
          body: requestBody instanceof FormData 
            ? requestBody 
            : JSON.stringify(requestBody),
          headers: {
            ...(requestBody instanceof FormData
              ? {}
              : { "Content-Type": "application/json" }),
            ...(options.headers || {}),
          },
        });

        const result = await response.json();

        if (!response.ok) {
          setError(result);
        } else {
          setData(result);
          setError(null);
        }
      } catch (error) {
        setError(error.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    },
    [url, options]
  );

  return { data, error, isLoading, putData };
};

export default usePut;
